import { Topbar, Sidebar } from "../../components";
import { useLocation } from 'react-router-dom';
import Loanme from './Loanme';
import Pension from './Pension';
import Pencash from './Pencash';
import Capitalme from './Capitalme';
import CedisCredit from './CedisCredit';
import Cashme from './Cashme';
import Investment from './Investment';
import Employer from './Employer';
import Salaried from './Salaried';
import SalariedAdvance from "./SalariedAdvance";
import { HugeiconsIcon } from '@hugeicons/react';
import { FileAddIcon } from '@hugeicons/core-free-icons';

const LOAN_LABELS = {
    pension: "Pension Loan",
    pensioncash: "PenCash Loan",
    capitalme: "CapitalMe Loan",
    cediscredit: "CedisCredit Loan",
    cashme: "CashMe Loan",
    investment: "Investment Loan",
    employer: "Employer Loan",
    salaried: "Salaried Loan",
    salariedAdvance: "Salaried Advance",
    loanme: "LoanMe",
};

function Questions() {

    const loanType = useLocation().pathname.split("/")[2];
    const client = JSON.parse(localStorage.getItem("client"));

    const switchLoans = () => {
        switch (loanType) {
            case "pension": return <Pension client={client} />;
            case "pensioncash": return <Pencash client={client} />;
            case "capitalme": return <Capitalme client={client} />;
            case "cediscredit": return <CedisCredit client={client} />;
            case "cashme": return <Cashme client={client} />;
            case "investment": return <Investment client={client} />;
            case "employer": return <Employer client={client} />;
            case "salaried": return <Salaried client={client} />;
            case "salariedAdvance": return <SalariedAdvance client={client} />;
            default: return <Loanme client={client} />;
        }
    };

    return (
        <div className="main-container">
            <Topbar />
            <Sidebar />

            <main className="main-content">
                <section className="section-container space-y-6">

                    <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-xl bg-blue-50 dark:bg-blue-900/30 border border-blue-100 dark:border-blue-800 flex items-center justify-center shrink-0">
                            <HugeiconsIcon icon={FileAddIcon} size={18} className="text-[#1e3a6e] dark:text-blue-400" />
                        </div>
                        <div>
                            <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-50">
                                {LOAN_LABELS[loanType] || "Loan"} Application
                            </h1>
                            <p className="text-sm text-gray-400">
                                {client?.name} &middot; {client?.phone}
                            </p>
                        </div>
                    </div>

                    {switchLoans()}

                </section>
            </main>
        </div>
    );
}

export default Questions;
